var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",staticClass:"cube-form",class:_vm.formClass,attrs:{"action":_vm.action},on:{"submit":_vm.submitHandler,"reset":_vm.resetHandler}},[_vm._t("default",_vm._l((_vm.groups),function(group,index){return _c('cube-form-group',{key:index,attrs:{"fields":group.fields,"legend":group.legend}})}))],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c1e684","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/cube-ui/src/components/form/form.vue
// module id = null
// module chunks = 